import * as React from "react";
import * as utils from "../utils";
import {Col, Row} from "react-bootstrap";
import EntryByTaskRow from "./EntryByTaskRow";

export default class EntryByTaskTable extends React.Component{

    empty(message){
        return (
            <Row className="entry-table-no-entries">
                <Col colSpan={12} style={{textAlign: "center"}}><em>{message}</em></Col>
            </Row>
        );
    }

    render(){

        const {entries, clients, projects, empty, onItemClick, usedTasksArray, totalMinutes, grandTotalMinutes} = this.props;

        if(entries.length === 0) return this.empty(empty);
        if(usedTasksArray.length === 0) return this.empty(empty);

        return ([
            <Row key="head" className="entry-table-head">
                <Col sm={2} className="project">Project</Col>
                <Col sm={6} className="task">Task</Col>
                <Col sm={1}>Entries</Col>
                <Col sm={3} className="hours">Hours</Col>
            </Row>,
            <div key="body" className="entry-table-body">
                {usedTasksArray.map((task, id) => {
                    return <EntryByTaskRow key={task.id}
                                     entries={entries.filter(entry => entry.task.id === task.id)}
                                     client={clients.items[task.client.id]}
                                     task={task}
                                     project={projects.items[task.project.id]}
                                     onItemClick={onItemClick}
                                     totalMinutes={totalMinutes[task.id]}
                    />
                })}
            </div>,
            <Row key="footer" className="entry-table-footer">
                <Col sm={3} smOffset={9}>{utils.formatHours(grandTotalMinutes)} <span style={{color: "#bbb", fontSize: "10pt"}}>total</span></Col>
            </Row>
        ]);
    }
}


// WEBPACK FOOTER //
// ./src/components/EntryByTaskTable.js